import React, { Component, Fragment } from "react";
import withRouter from "../withRouter/withRouter";
import { toEnglishNumber, toPersianNumber } from "../../classes/utils";
import "./FollowUp.css";
import { setupNotifications } from "../setupNotifications";

class FollowUp extends Component {
    constructor(props) {
        super(props);

        this.send_request = this.send_request.bind(this);
        this.pay_online = this.pay_online.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate();

        this.props.connection
            .is_notifications_subscribed()
            .then(() => {
                this.setState({ subscribed: true });
            })
            .catch(() => {
                this.setState({ subscribed: false });
            });
    }

    componentDidUpdate() {
        let { router, costumer } = this.props;
        let { id } = router.params;

        id && id !== this.state.id
            ? this.setState({ id, mobile: costumer.mobile })
            : this.send_request(id, costumer.mobile);
    }

    send_request(id, mobile) {
        let { connection, toast } = this.props;
        let { status } = this.state;
        id && (id = toEnglishNumber(id));
        mobile && (mobile = toEnglishNumber(mobile));
        !status &&
            id &&
            mobile &&
            connection
                .order_follow_up(id, mobile)
                .then((res) => {
                    let {
                        status,
                        items,
                        check,
                        totalPrice,
                        totalItemsPrice,
                        packingPrice,
                        shipping_cost,
                        tracking_code,
                    } = res.data;
                    this.setState({
                        id,
                        status,
                        items,
                        check,
                        totalPrice,
                        totalItemsPrice,
                        packingPrice,
                        shipping_cost,
                        retrieved: true,
                        tracking_code,
                    });
                })
                .catch((err) => {
                    err.response.status === 404
                        ? toast(
                              "خطا در دریافت اطلاعات",
                              "سفارش یافت نشد",
                              " danger"
                          )
                        : toast(
                              "خطا در دریافت اطلاعات",
                              "اطلاعات سفارش دریافت نشد" + err,
                              " danger"
                          );
                });
    }

    pay_online(id) {
        let { connection, toast } = this.props;

        connection
            .create_online_payment_session(id)
            .then((res) => {
                window.open(res.data.online_payment_url, "_self");
            })
            .catch((err) => {
                toast(
                    "ساخت سشن پرداخت",
                    "خطا در دریافت لینک پرداخت",
                    " danger"
                );
            });
    }

    state = {
        id: null,
        status: null,
        items: null,
        check: null,
        retrieved: false,
        totalPrice: null,
        totalItemsPrice: null,
        packingPrice: null,
        shipping_cost: null,
        subscribed: true,
    };
    render() {
        let { costumer } = this.props;

        let {
            id,
            retrieved,
            status,
            items,
            check,
            totalPrice,
            totalItemsPrice,
            packingPrice,
            shipping_cost,
            tracking_code,
            subscribed,
        } = this.state;
        let mobile = "";
        let _id = "";
        return (
            <div className='FollowUpComponent'>
                <div className='FollowUpContainer'>
                    <div className='id'>
                        <Fragment>
                            <div className='caption text info'>شماره سفارش</div>
                            {id ? (
                                <div className='value text primary'>
                                    {toPersianNumber(id)}
                                </div>
                            ) : (
                                <input
                                    type='text'
                                    onChange={(ev) => (_id = ev.target.value)}
                                />
                            )}
                        </Fragment>
                    </div>
                    {!costumer.mobile && !retrieved && (
                        <div className='mobile'>
                            <div className='caption text info'>
                                شماره موبایل
                            </div>
                            <input
                                type='tel'
                                onChange={(ev) => (mobile = ev.target.value)}
                            />
                        </div>
                    )}
                    {/*button*/}
                    {(!id || !costumer.mobile || !retrieved) && (
                        <button
                            className=' send btn confirm'
                            onClick={(ev) => {
                                this.send_request(
                                    id || _id,
                                    (costumer && costumer.mobile) || mobile
                                );
                            }}
                        >
                            ارسال درخواست
                        </button>
                    )}
                    {retrieved && (
                        <Fragment>
                            <div className='status'>
                                {!subscribed && (
                                    <div
                                        style={{
                                            border: "2px solid red",
                                            padding: "2px 5px",
                                            borderRadius: "10px",
                                            margin: "10px 3px",
                                        }}
                                    >
                                        <div className='text info'>
                                            جهت اطلاع از وضعیت سفارش خودتون
                                            میتونید نوتیفیکیشن ها رو فعال کنید.
                                        </div>

                                        <button
                                            className='btn info'
                                            onClick={() => {
                                                setupNotifications(
                                                    this.props.connection
                                                )
                                                    .then((result) => {
                                                        this.props.toast(
                                                            "آگاه ساز",
                                                            "آگاهساز فعال شد.",
                                                            " confirm"
                                                        );
                                                        this.setState({
                                                            subscribed: true,
                                                        });
                                                    })
                                                    .catch((err) => {
                                                        this.props.toast(
                                                            "آگاه ساز",
                                                            "خطا در فعالسازی آگاه ساز : ." +
                                                                err,
                                                            " error"
                                                        );
                                                    });
                                            }}
                                        >
                                            {" "}
                                            فعالسازی آگاه ساز ها
                                        </button>
                                    </div>
                                )}
                                <div className='caption text info'>وضعیت</div>
                                <div className='value'>
                                    <i
                                        className={
                                            (status === "checkOut" &&
                                                "fa-solid fa-list-check text info") ||
                                            (status === "notPayed" &&
                                                "fa-solid fa-money-bill-wave text warning") ||
                                            (status === "pending" &&
                                                "fa-solid fa-spinner text confirm") ||
                                            (status === "sent" &&
                                                "fa-solid fa-truck-fast text primary")
                                        }
                                    ></i>
                                    {(status === "checkOut" && (
                                        <div className='state text info'>
                                            در حال چک کردن
                                        </div>
                                    )) ||
                                        (status === "notPayed" && (
                                            <div className='state text warning'>
                                                پرداخت نشده
                                                <div className='pay_now'>
                                                    <button
                                                        className='btn confirm'
                                                        onClick={(ev) => {
                                                            this.props.router.navigate(
                                                                `/pay/offline/${id}/${
                                                                    (costumer &&
                                                                        costumer.mobile) ||
                                                                    mobile
                                                                }`
                                                            );
                                                        }}
                                                    >
                                                        <i className='fa-regular fa-credit-card'></i>
                                                        پرداخت آفلاین
                                                    </button>
                                                    <button
                                                        className='btn confirm'
                                                        onClick={(ev) => {
                                                            this.pay_online(id);
                                                        }}
                                                    >
                                                        <i className='fa-regular fa-credit-card'></i>
                                                        پرداخت آنلاین
                                                    </button>
                                                </div>
                                            </div>
                                        )) ||
                                        (status === "pending" && (
                                            <div className='state text confirm'>
                                                در حال انجام
                                            </div>
                                        )) ||
                                        (status === "sent" && (
                                            <div className='state text primary'>
                                                ارسال شده
                                                <div className='tracking_code'>
                                                    <div className='name'>
                                                        کد رهگیری :
                                                    </div>
                                                    <div className='value'>
                                                        {toPersianNumber(
                                                            tracking_code
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                            <div className='items'>
                                {items.map((item, index) => {
                                    let {
                                        thumbnail,
                                        name,
                                        amount,
                                        unit,
                                        color,
                                        id,
                                    } = item;
                                    return (
                                        <div className='item' key={index}>
                                            <div className='image'>
                                                <img
                                                    src={thumbnail.url}
                                                    alt=''
                                                />
                                            </div>
                                            <a
                                                className='name text primary'
                                                href={"/item/" + id}
                                            >
                                                {name}
                                            </a>
                                            <div
                                                className='color'
                                                style={{
                                                    color: color.color,
                                                }}
                                            >
                                                {color.name || (
                                                    <div
                                                        className='colorCircle'
                                                        style={{
                                                            backgroundColor:
                                                                color.color,
                                                        }}
                                                    ></div>
                                                )}
                                            </div>
                                            <div className='amount text secondary'>
                                                {`${toPersianNumber(
                                                    parseFloat(amount),
                                                    true
                                                )}  ${unit}`}
                                            </div>

                                            <div className='price text secondary'>
                                                {check && check.length > 0 ? (
                                                    <div>
                                                        {`${toPersianNumber(
                                                            check[index].price,
                                                            true
                                                        )}  تومان`}
                                                    </div>
                                                ) : (
                                                    <div className='checking'>
                                                        <i className='ri-loader-line text info'></i>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className='invoice'>
                                <div className='caption'>فاکتور</div>
                                {totalItemsPrice && (
                                    <div className='totalItemsPrice'>
                                        <div className='caption text info'>
                                            کل قیمت اجناس
                                        </div>
                                        <div className='price'>
                                            {`${toPersianNumber(
                                                totalItemsPrice.toString(),
                                                true
                                            )}  تومان`}
                                        </div>
                                    </div>
                                )}
                                {packingPrice && (
                                    <div className='packingPrice'>
                                        <div className='caption text info'>
                                            هزینه بسته بندی
                                        </div>
                                        <div className='price'>
                                            {`${toPersianNumber(
                                                packingPrice.toString(),
                                                true
                                            )}  تومان`}
                                        </div>
                                    </div>
                                )}
                                {shipping_cost && (
                                    <div className='shipping_cost'>
                                        <div className='caption text info'>
                                            هزینه ارسال
                                        </div>
                                        <div className='price'>
                                            {`${toPersianNumber(
                                                shipping_cost.toString(),
                                                true
                                            )}  تومان`}
                                        </div>
                                    </div>
                                )}
                                {totalPrice && (
                                    <div className='totalPrice'>
                                        <div className='caption text info'>
                                            قیمت کل
                                        </div>
                                        <div className='price'>
                                            {`${toPersianNumber(
                                                totalPrice.toString(),
                                                true
                                            )}  تومان`}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='ticket'></div>
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(FollowUp);
